import React, { useCallback } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import * as Pages from './pages';

function StaticContentContainer() {
  const { url } = useRouteMatch();

  const getPath = useCallback(
    (page: string) => {
      return `${url}/${page}`;
    },
    [url]
  );

  // Put all data logic here...
  return (
    <Switch>
      <Route path={getPath('')} component={Pages.Home} exact />
      <Route path={getPath('faq')} component={Pages.HouseShareFaq} />
      <Route path={getPath('help') + '/:incomingKey?'} component={Pages.Help} />
      <Route path={getPath('shuol')} component={Pages.AboutShuoLicense} />
      <Route path={getPath('ordinance')} component={Pages.Ordinance} />
      <Route path={getPath('contact')} component={Pages.Contact} />
      <Redirect to={getPath('')} />
    </Switch>
  );
}

export default StaticContentContainer;
